import LoadingBarOneOff from './view';
export default LoadingBarOneOff;
